import { render, staticRenderFns } from "./Grupo.vue?vue&type=template&id=acaa566a&"
import script from "./Grupo.vue?vue&type=script&lang=js&"
export * from "./Grupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports